function fmoney(s) {
    let n = 2;
    n = n > 0 && n <= 20 ? n : 2;
    s = parseFloat((s + "").replace(/[^\d\.-]/g, "")).toFixed(n) + "";
    var l = s.split(".")[0].split("").reverse(),
        r = s.split(".")[1];
    let t = "";
    for (let i = 0; i < l.length; i++) {
        t += l[i] + ((i + 1) % 3 == 0 && (i + 1) != l.length ? "," : "");
    }
    return t.split("").reverse().join("") + "." + r;
}
function fmoney2(s) {
    let n = 2;
    n = n > 0 && n <= 20 ? n : 2;
    s = parseFloat((s + "").replace(/[^\d\.-]/g, "")).toFixed(n) + "";
    var l = s.split(".")[0].split("").reverse(),
        r = s.split(".")[1];
    let t = "";
    for (let i = 0; i < l.length; i++) {
        t += l[i]
    }
    return t.split("").reverse().join("") + "." + r;
}

export const moneyP = (num) => {
    let n = Number(num);
    let isF = Number.isFinite(n);
    if(isF) {
        if (n == 0) {
            let outnum = '0.00'
            return outnum;
        } else {
            if (n != '') {
                if (n < 0) {
                    let outnum = fmoney(-n)
                    return '-' + outnum
                } else {
                    let outnum = fmoney(n)
                    return outnum
                }
            }
        }
    } else {
        let outnum = '0.00'
        return outnum;
    }
}
export const moneyP2 = (num) => {
    let n = Number(num);
    let isF = Number.isFinite(n);
    if(isF) {
        if (n == 0) {
            let outnum = '0.00'
            return outnum;
        } else {
            if (n != '') {
                if (n < 0) {
                    let outnum = fmoney2(-n)
                    return '-' + outnum
                } else {
                    let outnum = fmoney2(n)
                    return outnum
                }
            }
        }
    } else {
        let outnum = '0.00'
        return outnum;
    }
}


// WEBPACK FOOTER //
// ./src/filter/money.js